(() => {
  console.log('SELARAS VARIANT-HOVER GELADEN');
  const SWATCH_SELECTOR = '[productimage]';
  const IMAGE_SELECTOR = '.card__media img';
  const SELECTED_CLASS = 'variant-hover-selected';
  const FADE_DURATION = 180;

  const preloadedImages = new Set();
  let changeCounter = 0;

  /**
   * Findet die zugehörige Produktkarte.
   */
  const findCard = (element) => {
    return (
      element?.closest('.card-wrapper') ||
      element?.closest('.grid__item') ||
      null
    );
  };

  /**
   * Findet das sichtbare Hauptbild der Produktkarte.
   */
  const findCardImage = (element) => {
    const card = findCard(element);
    if (!card) return null;

    return card.querySelector(IMAGE_SELECTOR);
  };

  /**
   * Speichert das ursprüngliche freigestellte Produktbild.
   */
  const saveOriginalImage = (image) => {
    if (!image) return;

    if (image.dataset.variantHoverOriginalSaved === 'true') {
      return;
    }

    image.dataset.variantHoverOriginalSrc =
      image.getAttribute('src') || '';

    image.dataset.variantHoverOriginalSrcset =
      image.getAttribute('srcset') || '';

    image.dataset.variantHoverOriginalSizes =
      image.getAttribute('sizes') || '';

    image.dataset.variantHoverOriginalSaved = 'true';
  };

  /**
   * Speichert alle ursprünglichen Produktbilder.
   */
  const saveAllOriginalImages = (root = document) => {
    if (!(root instanceof Element || root === document)) return;

    if (
      root instanceof Element &&
      root.matches(IMAGE_SELECTOR)
    ) {
      saveOriginalImage(root);
    }

    root.querySelectorAll(IMAGE_SELECTOR).forEach((image) => {
      saveOriginalImage(image);
    });
  };

  /**
   * Lädt ein Variantenbild vor.
   */
  const preloadImage = (imageUrl) => {
    if (!imageUrl || preloadedImages.has(imageUrl)) {
      return Promise.resolve();
    }

    preloadedImages.add(imageUrl);

    return new Promise((resolve) => {
      const preload = new Image();

      preload.onload = resolve;
      preload.onerror = resolve;
      preload.src = imageUrl;

      if (preload.complete) {
        resolve();
      }
    });
  };

  /**
   * Setzt die Bildattribute.
   */
  const setImageAttributes = (image, imageUrl) => {
    image.setAttribute('src', imageUrl);
    image.setAttribute('srcset', imageUrl);
    image.removeAttribute('sizes');
  };

  /**
   * Tauscht das Produktbild mit einer sanften Animation.
   */
  const changeImage = async (
    image,
    imageUrl,
    useAnimation = true
  ) => {
    if (!image || !imageUrl) return;

    saveOriginalImage(image);

    const currentChange = ++changeCounter;
    image.dataset.variantHoverChange = String(currentChange);

    await preloadImage(imageUrl);

    if (
      image.dataset.variantHoverChange !== String(currentChange)
    ) {
      return;
    }

    if (!useAnimation) {
      setImageAttributes(image, imageUrl);
      image.style.opacity = '1';
      return;
    }

    const currentSrc = image.getAttribute('src') || '';

    if (currentSrc === imageUrl) {
      image.style.opacity = '1';
      return;
    }

    image.style.opacity = '0';

    window.setTimeout(() => {
      if (
        image.dataset.variantHoverChange !== String(currentChange)
      ) {
        return;
      }

      setImageAttributes(image, imageUrl);

      requestAnimationFrame(() => {
        image.style.opacity = '1';
      });
    }, FADE_DURATION);
  };

  /**
   * Zeigt das Bild eines Farbpunkts.
   */
  const showVariantImage = (
    swatch,
    useAnimation = true
  ) => {
    if (!swatch) return;

    const imageUrl = swatch.getAttribute('productimage');
    if (!imageUrl) return;

    const image = findCardImage(swatch);
    if (!image) return;

    const card = findCard(swatch);

    if (card) {
      card.dataset.variantHoverActive = 'true';
      card.dataset.variantHoverUrl = imageUrl;
    }

    changeImage(image, imageUrl, useAnimation);
  };

  /**
   * Markiert genau den tatsächlich angeklickten Farbpunkt.
   */
 const markSelectedSwatch = (swatch) => {
  const card = findCard(swatch);
  if (!card) return;

  card.querySelectorAll(SWATCH_SELECTOR).forEach((item) => {
    item.classList.remove(SELECTED_CLASS);
    item.style.removeProperty('--selected-swatch-color');
  });

  const colorElement =
    swatch.querySelector('[style*="background-color"]') ||
    swatch.querySelector('.globo-border-color-swatch') ||
    swatch.querySelector('.swatch-anchor');

  if (colorElement) {
    const swatchColor =
      window.getComputedStyle(colorElement).backgroundColor;

    swatch.style.setProperty(
      '--selected-swatch-color',
      swatchColor
    );
  }

  swatch.classList.add(SELECTED_CLASS);
};

  /**
   * Stellt das ursprüngliche freigestellte Produktbild wieder her.
   */
  const restoreOriginalImage = (swatch) => {
    const image = findCardImage(swatch);

    if (
      !image ||
      image.dataset.variantHoverOriginalSaved !== 'true'
    ) {
      return;
    }

    const card = findCard(swatch);

    /*
     * Nach einem Klick bleibt die ausgewählte Variante sichtbar.
     */
    if (card?.dataset.variantHoverClicked === 'true') {
      return;
    }

    const originalSrc =
      image.dataset.variantHoverOriginalSrc || '';

    if (!originalSrc) return;

    const currentChange = ++changeCounter;
    image.dataset.variantHoverChange = String(currentChange);
    image.style.opacity = '0';

    window.setTimeout(() => {
      if (
        image.dataset.variantHoverChange !== String(currentChange)
      ) {
        return;
      }

      image.setAttribute('src', originalSrc);

      const originalSrcset =
        image.dataset.variantHoverOriginalSrcset || '';

      const originalSizes =
        image.dataset.variantHoverOriginalSizes || '';

      if (originalSrcset) {
        image.setAttribute('srcset', originalSrcset);
      } else {
        image.removeAttribute('srcset');
      }

      if (originalSizes) {
        image.setAttribute('sizes', originalSizes);
      } else {
        image.removeAttribute('sizes');
      }

      if (card) {
        delete card.dataset.variantHoverActive;
        delete card.dataset.variantHoverUrl;
      }

      requestAnimationFrame(() => {
        image.style.opacity = '1';
      });
    }, FADE_DURATION);
  };

  /**
   * Fügt die Übergangsanimation für Produktbilder hinzu.
   */
  const addTransitionStyles = () => {
    if (document.getElementById('variant-hover-styles')) return;

    const style = document.createElement('style');
    style.id = 'variant-hover-styles';

    style.textContent = `
      .card__media img {
        transition: opacity ${FADE_DURATION}ms ease-in-out;
      }

      @media (prefers-reduced-motion: reduce) {
        .card__media img {
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  };

  /**
   * Lädt alle Variantenbilder im Hintergrund vor.
   */
  const preloadAllVariantImages = (root = document) => {
    if (!(root instanceof Element || root === document)) return;

    if (
      root instanceof Element &&
      root.matches(SWATCH_SELECTOR)
    ) {
      preloadImage(root.getAttribute('productimage'));
    }

    root.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
      preloadImage(swatch.getAttribute('productimage'));
    });
  };

  /**
   * Desktop: Variantenbild beim Überfahren anzeigen.
   */
  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    showVariantImage(swatch);
  });

  /**
   * Desktop: Beim Verlassen das Ausgangsbild anzeigen,
   * solange keine Farbe angeklickt wurde.
   */
  document.addEventListener('mouseout', (event) => {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    const nextSwatch =
      event.relatedTarget?.closest?.(SWATCH_SELECTOR);

    const currentCard = findCard(swatch);
    const nextCard = nextSwatch ? findCard(nextSwatch) : null;

    if (nextSwatch && currentCard === nextCard) {
      return;
    }

    restoreOriginalImage(swatch);
  });

  /**
   * Klick oder Fingertipp:
   * Bild und optische Markierung bleiben auf der gewählten Farbe.
   */
  document.addEventListener('click', async (event) => {
  if (!event.isTrusted) return;

  const swatch = event.target.closest('label.swatch-anchor');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  const link = card?.querySelector('a[href*="/products/"]');
  const color = swatch.previousElementSibling?.value;

  if (!link || !color) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const url = new URL(link.href);

  try {
    const response = await fetch(
      url.pathname + '.js'
    );
    if (!response.ok) throw new Error('Produkt nicht geladen');

    const product = await response.json();
    const matchingVariants = product.variants.filter(v =>
  v.options.some(option =>
    option.toLowerCase() === color.toLowerCase()
  )
);

const variant =
  matchingVariants.find(v => v.available) ||
  matchingVariants[0];

    if (variant) {
      url.searchParams.set('variant', variant.id);
    }

    window.location.assign(url.href);
  } catch (error) {
    window.location.assign(url.href);
  }
}, true);
  document.addEventListener('click', (event) => {
    if (!event.isTrusted) return;

    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    const imageUrl = swatch.getAttribute('productimage');
    const card = findCard(swatch);

    if (!imageUrl || !card) return;

    card.dataset.variantHoverClicked = 'true';
    card.dataset.variantHoverUrl = imageUrl;

    /*
     * Nur der wirklich angeklickte Farbpunkt wird vergrößert.
     */
    markSelectedSwatch(swatch);

    /*
     * Sofort sichtbare Reaktion.
     */
    showVariantImage(swatch);

    /*
     * Nach der GLO-Aktualisierung das korrekte Bild erneut setzen.
     */
    window.setTimeout(() => {
      const currentImage = card.querySelector(IMAGE_SELECTOR);
      if (!currentImage) return;

      changeImage(currentImage, imageUrl, false);
    }, 100);

    /*
     * Zweite Absicherung für langsamere Aktualisierungen.
     */
    window.setTimeout(() => {
      const currentImage = card.querySelector(IMAGE_SELECTOR);
      if (!currentImage) return;

      changeImage(currentImage, imageUrl, false);
    }, 350);
  });

  /**
   * Dynamisch nachgeladene Elemente erkennen.
   */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        saveAllOriginalImages(node);
        preloadAllVariantImages(node);
              });
    });
  });


  const initialize = () => {
    addTransitionStyles();
const placeRatings = () => {
  document.querySelectorAll('.grid__item').forEach((card) => {
    const swatches = card.querySelector('.swatches-globo--list');
    const rating = card.querySelector('.rating');
    const ratingCount = card.querySelector('.rating-count');

    if (!rating) return;

    if (!rating.dataset.waitingForSwatches) {
      rating.dataset.waitingForSwatches = 'true';
      rating.style.visibility = 'hidden';

      if (ratingCount) {
        ratingCount.style.visibility = 'hidden';
      }
    }

    if (swatches) {
      swatches.insertAdjacentElement('afterend', rating);

      if (ratingCount) {
        rating.insertAdjacentElement('afterend', ratingCount);
        ratingCount.style.visibility = 'visible';
      }

      rating.style.visibility = 'visible';
    }
  });
};

placeRatings();

const ratingInterval = setInterval(() => {
  placeRatings();

  const waiting = [...document.querySelectorAll('.rating')].some(
    rating => rating.style.visibility === 'hidden'
  );

  if (!waiting) {
    clearInterval(ratingInterval);
  }
}, 50);

setTimeout(() => clearInterval(ratingInterval), 5000);
    /*
     * Beim ersten Laden wird bewusst kein Farbpunkt von unserem
     * Code als ausgewählt markiert.
     */
    document.querySelectorAll(`.${SELECTED_CLASS}`).forEach((item) => {
      item.classList.remove(SELECTED_CLASS);
    });

    /*
     * Zuerst die freigestellten Ausgangsbilder sichern.
     */
    saveAllOriginalImages();

    /*
     * Variantenbilder anschließend im Hintergrund vorladen.
     */
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        preloadAllVariantImages();
      });
    } else {
      window.setTimeout(() => {
        preloadAllVariantImages();
      }, 500);
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();

/* SELARAS – Farbverfügbarkeit in Kategorieübersichten */
(() => {
  'use strict';

  const productCache = new Map();
  const pending = new Map();
  const STYLE_ID = 'selaras-collection-color-availability';

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .swatches-globo .selaras-color-unavailable label.swatch-anchor {
      opacity: 0.4 !important;
    }
    .swatches-globo .selaras-color-available label.swatch-anchor {
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);

  async function getProduct(path) {
    if (productCache.has(path)) return productCache.get(path);
    if (pending.has(path)) return pending.get(path);

    const request = fetch(path + '.js')
      .then(response => {
        if (!response.ok) throw new Error('Produkt nicht geladen');
        return response.json();
      })
      .then(product => {
        productCache.set(path, product);
        return product;
      })
      .finally(() => pending.delete(path));

    pending.set(path, request);
    return request;
  }

  async function updateCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const swatches = card.querySelectorAll(
      '.swatches-globo li.swatches-options'
    );

    if (!link || !swatches.length) return;

    let path;
    try {
      path = new URL(link.href).pathname;
    } catch {
      return;
    }

    try {
      const product = await getProduct(path);
      const colorIndex = product.options.findIndex(option =>
        /^(farbe|color|colour)$/i.test(option.name)
      );

      if (colorIndex < 0) return;

      swatches.forEach(swatch => {
        const color = swatch.querySelector('input')?.value;
        if (!color) return;

        const variants = product.variants.filter(variant =>
          variant.options[colorIndex].toLowerCase() ===
          color.toLowerCase()
        );

        if (!variants.length) return;

        const available = variants.some(variant => variant.available);

        swatch.classList.toggle(
          'selaras-color-unavailable', !available
        );
        swatch.classList.toggle(
          'selaras-color-available', available
        );

        // Fehlerhafte GLO-Markierungen korrigieren.
        swatch.classList.toggle('globo-sold-out', !available);
        swatch.classList.toggle('globo-out-of-stock', !available);
        swatch.classList.toggle('globo-sold-out-opacity', !available);
      });
    } catch (error) {
      console.warn('SELARAS Farbverfügbarkeit:', error);
    }
  }

  function updateAll() {
    document.querySelectorAll('.card-wrapper').forEach(updateCard);
  }

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(updateAll, 0);
  });

  function start() {
    updateAll();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
